import React from "react";
import {connect} from "react-redux";
import {withCommands} from "./CommandsProvider";
import {JobQueries, JobTypeSelector} from "./";
import * as at from "../actionTypes";


class UnconnectedManageToolFilters extends React.Component {
  componentDidMount() {
    this.props.commands.checkLoadJobTypes()
  }

  componentWillReceiveProps() {
    this.props.commands.checkLoadJobTypes()
  }

  render() {
    return <div>
      <div className="clearfix">
        <small>
          <a className="link pull-right" tabIndex={0} onClick={() => this.props.dispatch({ type: at.RESET })}>
            reset
          </a>
        </small>
      </div>
      <div className="control-group" style={{marginBottom: '10px'}}>
        <label>Job Type</label>
        <JobTypeSelector />
      </div>
      <hr />
      <JobQueries/>
    </div>
  }

}

export const ManageToolFilters = withCommands(connect(function mapStateToProps(state, ownProps) {
  return { state, ...ownProps }
})(UnconnectedManageToolFilters));
